<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="验算服配置读取" name="node_config">
                        <el-form label-width="10%" label-suffix=":" label-position="right">
                            <el-form-item label="填入地址">
                                <el-input v-model="yunweiNodeForm.serverUrl"  ></el-input>
                            </el-form-item>
                            <el-form-item label="端口信息">
                                <el-input v-model="yunweiNodeForm.port"  ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" @click="v2CoreGetLocalConfig">点击读取</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="战斗验算结果比对" name="node_validate">
                        <el-form label-width="10%" label-suffix=":" label-position="right">
                            <el-form-item label="填入地址">
                                <el-input v-model="yunweiBattleValidateForm.serverUrl"  ></el-input>
                            </el-form-item>
                            <el-form-item label="端口">
                                <el-input v-model="yunweiBattleValidateForm.port" ></el-input>
                            </el-form-item>
                            <el-form-item label="战斗mode">
                                <el-input-number v-model="yunweiBattleValidateForm.mode" ></el-input-number>
                            </el-form-item>
                            <el-form-item label="战斗校验-lineup1">
                                <el-input v-model="yunweiBattleValidateForm.lineup1" ></el-input>
                            </el-form-item>
                            <el-form-item label="战斗校验-lineup2">
                                <el-input v-model="yunweiBattleValidateForm.lineup2" ></el-input>
                            </el-form-item>
                            <el-form-item label="战斗校验-battleParams">
                                <el-input v-model="yunweiBattleValidateForm.battleParams" ></el-input>
                            </el-form-item>
                            <el-form-item label="战斗校验-battleVersion">
                                <el-input-number v-model="yunweiBattleValidateForm.battleVersion" ></el-input-number>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" @click="v2CoreRun">结果校验</el-button>
                            </el-form-item>
                        </el-form>

                    </el-tab-pane>
                </el-tabs>
            </section>
        </div>
    </el-card>
</template>

<script>
import FileSaver from 'file-saver'
import warApi from '../../service/war_api'
import actionConfirm from '../../mixins/action_confirm'
import {mapState} from 'vuex';

export default {
    data() {
        return {
            title: this.$route.meta.title,
            activeName:"node_config",
            yunweiNodeForm:{
                serverUrl:'',
                port: 8101
            },
            yunweiBattleValidateForm : {
                serverUrl: "",
                port : 8101,
                mode:1,
                lineup1:"",
                lineup2:"",
                battleParams:"",
                battleVersion:"",
                result:""
            },
        }
    },
    mixins: [actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken
        }),
    },
    mounted() {
    },
    created() {
        this.getLangs();
    },
    methods: {
        handleClick(tab,event){
        },
        //配置信息读取
        v2CoreGetLocalConfig(){
            let self = this;
            warApi.v2CoreGetLocalConfig({
                token: self.token,
                nodeReadForm: self.yunweiNodeForm
            }).then(res => {
                const blob = new Blob([res], {type: 'application/json'});
                FileSaver.saveAs(blob, 'Warmachine('+self.yunweiNodeForm.serverUrl+')-'+self.yunweiNodeForm.port+'.json');
            })
        },

        v2CoreRun(){
            let self = this;
            warApi.v2CoreRun({
                token: self.token,
                nodeCoreRunForm: self.yunweiBattleValidateForm
            }).then(res => {
                const blob = new Blob([res], {type: 'application/json'});
                FileSaver.saveAs(blob, 'Node('+self.yunweiBattleValidateForm.serverUrl+')-'+self.yunweiBattleValidateForm.port+'-result.json');
            })
        },
    }
};
</script>

<style lang="less">
.el-table__row .el-table__row--level-1 {
    background-color: #999999 !important;
}

.el-table:not(.el-table–scrollable-x) .el-table__fixed{
    height: 100% !important;
}

.server-row .el-input {
    margin-bottom: 10px;
}

.combine-tip {
    color: red;
    margin-bottom: 10px;
}

.upload-server {
    margin-left: 10px;
}

.sort-tip {
    color: red;
}

.white-list {
    width: 100px;
}

.volley-tip {
    color: red;
}

.login-btn-group {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/dev_tools/beasts_node.vue